const lang = "en-US";

module.exports = lang;
